import type { InstitutionTheme } from '../types';
import { ucdavisColors } from './colors';

// UC Davis institutional theme (W56 S3, Worker D).
//
// Brand strings per the S1 fact sheet (admin_tools/backend/data/onboarding/ucdavis/fact_sheet.yaml):
// official university name; "Schedule Builder" is the registration tool the catalog itself names
// ("Prerequisites for most undergraduate courses are checked by Schedule Builder",
// probes/about_courses.html). Colors per ./colors.ts (one first-party source; second source pending).
//
// Example course codes, all active in the 2026-2027 catalog (titles from courses_parsed.json): ECS 036A
// (Programming & Problem Solving — zero-padded with a suffix, the format's signature), MAT 021A
// (Calculus), UWP 001
// (Introduction to Academic Literacies — the composition course every college lists). First entry is
// the primary single example shown in placeholder text.
export const ucdavisTheme: InstitutionTheme = {
  slug: 'ucdavis',
  universityName: 'University of California, Davis',
  universityShortName: 'UC Davis',
  registrationPortalName: 'Schedule Builder',
  exampleCourseCodes: ['ECS 036A', 'MAT 021A', 'UWP 001'],
  colors: ucdavisColors,
};
